'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'industry-windows';
var width = 512;
var height = 512;
var aliases = [127981,"industry-alt"];
var unicode = 'f3b3';
var svgPathData = 'M0 32l128 0 0 192 192-96 0 96 192-96 0 352-512 0 0-448zM288 320l-64 0 0 64 64 0 0-64zm-128 0l-64 0 0 64 64 0 0-64zm256 0l-64 0 0 64 64 0 0-64z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faIndustryWindows = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;